module.exports = __webpack_public_path__ + "media/images/flags/32/Mars-a32c7e667b06d64ff9e035cfcf08e3d7.png";